import { DatePipe, Location } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { ConfirmationService } from "primeng/api";
import "rxjs/Rx";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";

@Component({
    selector: "app-warehouse-lifecycle",
    templateUrl: "./warehouse-lifecycle.component.html",
    styleUrls: ["./warehouse-lifecycle.component.css"],
    providers: [ConfirmationService]
})
export class WarehouseLifecycleComponent implements OnInit {
    rowsNo = 10;
    offset:number = 0;
    pageSize:number = 10;
    noOfRecords: number=0;
    // hasSearched=false;
    sortField: String="dateTimeReceived";
    sortOrder: number = -1;
    depositorOrderNumber: String;
    database: String;
    noRecords: boolean = false;
    lifecyclesearchData: any = [];
    display: boolean;
    detailInfoData: any = [];
    asndetailInfoData: any = [];
    invoicedetailInfoData: any = [];
    paymentdetailInfoData: any = [];
    document: any = {};
    senderArray = [];
    receiverArray = [];
    selected;
    statusArray = [];
    ackStatusArray = [];
    correlationArray = [];
    public count = 0;
    public show: boolean = false;
    transactionArray = [];
    dtOptions: DataTables.Settings = {};
    userRole: string;
    tableHeaders: { field: string; header: string }[];
    lifeCycleHeaders: { field: string; header: string; width: string; }[];
    isFromDocRepo: string;
    mailPopup: boolean;
    postTransFilePath: any;
    mulPostTransData: any=[];
    displayPostTransDownload: boolean;
    loader: boolean=false;
    instanceId: any;
    headers: HttpHeaders;
    displayPreTranslation: boolean;
    previewTranslation: any;
    filePath: any;
    constructor(
        private myservice: MyserviceService,
        private router: Router,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        public location: Location,
        private http: HttpClient,
        public datepipe: DatePipe,
        public activatedRoute: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.isFromDocRepo = this.activatedRoute.snapshot.paramMap.get("from");
        this.userRole = this.session.retrieve("userRole");
        this.lifeCycleHeaders = [
            { field: "dateTimeReceived", header: "Date Time",width:"140px" },
            { field: "fileId", header: "Instance Id",width:"100px" },
            { field: "depositorOrderNumber", header: "Cust Order #",width:"200px" },
            { field: "transactionType", header: "Transaction #",width:"120px" },
            { field: "partner", header: "Partner",width:"160px" },
            { field: "direction", header: "Direction",width:"100px" },
            { field: "status", header: "Status",width:"120px" },
            { field: "ackStatus", header: "ACK/API Status",width:"130px" },
            { field: "reProcessStatus", header: "Reprocess",width:"120px" },
        ];
        this.dtOptions = {
            order: [[0, "desc"]],
        };

        this.depositorOrderNumber = this.localstorage.retrieve(
            "depositorOrderNumber"
        );
        this.database = this.localstorage.retrieve("database");

        this.headers = new HttpHeaders();
        this.headers = this.headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.search(true);
    }
    search(countFlag=false){
        this.loader=true;
        let reqPayload={
            sortField:this.sortField,
            depositorOrderNumber:this.depositorOrderNumber,
            offSet:this.offset,
            limit:this.pageSize,
            database:this.database,
            countFlag:countFlag,
            sortOrder:this.sortOrder == 1 ? "ASC" : "DESC"
        }
        this.http.post(
                environment.apiUrl +"/lifecycle/search",
                reqPayload,
                {headers: this.headers}
            )
            .subscribe((res:any) => {
                this.loader=false;
                this.lifecyclesearchData = res.data;
                if (countFlag) {
                    this.noOfRecords = res.totalRecordsCount;
                }
            });
    }

    backClicked() {
        if (this.isFromDocRepo=="m-doc-repository") {
            this.router.navigate([
                "/mscvp/m-doc-repository",
                { isback: "data" },
            ]);   
        }
        else{this.router.navigate([
            "/mscvp/division",
            { isback: "data" },
        ]);}
    }
    //For server side pagination and sorting
    onPagination(data) {
        this.rowsNo = data.first + data.rows >= this.noOfRecords ? this.noOfRecords : data.first + data.rows;
        //Checking if the previous pagination and sorting fields are different with latest fields or not to reduce the API hits
        if (data.first != this.offset || data.rows != this.pageSize || data.sortField != this.sortField || data.sortOrder != this.sortOrder) {
            this.offset = data.first;
            this.pageSize = data.rows;
            this.sortField = data.sortField;
            this.sortOrder = data.sortOrder;
            this.search();
        }
    }
    detailInfo(depositorOrderNumber, fileId, database, transaction) {
        this.instanceId=fileId;
        this.display = true;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(
                environment.apiUrl +
                    "/lifecycle/detailInfo/" +
                    depositorOrderNumber +
                    "/" +
                    fileId +
                    "/" +
                    database +
                    "/" +
                    transaction,
                { headers: headers }
            )

            .subscribe((data) => {
                this.detailInfoData = data;
                this.postTransFilePath=this.detailInfoData.postTransFilePath.split(',')
            });
    }

    translationFileDownload(filePath) {
        // this.myservice.translationFileDownload(filePath);
        this.loader = true   
        this.myservice.translationFilePreview(filePath).subscribe((data: any) => {
            this.loader = false
            setTimeout(() => {
                this.previewTranslation = data;  
                this.displayPreTranslation = true; 
            }, 500);             
        });
        this.filePath = filePath
    }

    download(){
        this.myservice.translationFileDownload(this.filePath);
    }
    openMailDialog(){
        this.mailPopup=true;
    }
    updateDialog(){
        this.mailPopup=false
    }
    showMultipostTransDownload(){
        this.displayPostTransDownload=true
        this.mulPostTransData=[];
        this.postTransFilePath.map((data)=>this.mulPostTransData.push({path:data,isSelected:false}))   
    }
    updateMultiFileDialog(data){
        (data=="false")?this.displayPostTransDownload=false:null;
    }
    //For showing loader on multiple post trans file download
    updateloaderVisibilty(data) {
        this.loader = data == "true" ? true : false;
    }
}
